
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.18 10.445c-.83 0-1.504-.674-1.504-1.504V4H8.984a2.366 2.366 0 00-2.363 2.363v17.274A2.366 2.366 0 008.984 26h12.032a2.366 2.366 0 002.363-2.363V10.445h-5.2zm-8.035 9.024h3.124a.645.645 0 110 1.289h-3.124a.645.645 0 010-1.29zM9.5 16.676c0-.356.289-.645.645-.645h9.453a.645.645 0 010 1.29h-9.453a.645.645 0 01-.645-.645zm10.098-4.082a.644.644 0 110 1.289h-9.453a.645.645 0 010-1.29h9.453z","fill":"#525F7F"}}),_c('path',{attrs:{"d":"M17.965 8.941c0 .119.096.215.215.215h4.912a2.358 2.358 0 00-.452-.59l-4.143-3.92a2.37 2.37 0 00-.532-.379v4.674z","fill":"#B4BCCF"}})])
          )
        }
      }
    